<div class="eos-notification">
  <h4>{{data.header}}</h4>
  <p>{{data.message}}</p>
  <ng-container *ngIf="data.template" [ngTemplateOutlet]="data.template"></ng-container>
  <button type="button" aria-label="Close notification" mat-icon-button (click)="dismiss()">
    <mat-icon>close</mat-icon>
  </button>
</div>
